
import PropTypes from 'prop-types';
import DataTable from './DataTable';
import dataFormat from "layouts/merchantTopup/merchantOverview/data";
function merchantOverview(props) {
    const { list } = props
    const { columns, rows } = dataFormat(list);
    return (
        <DataTable
            table={{ columns, rows }}
            showTotalEntries={false}
            isSorted={false}
            noEndBorder
            entriesPerPage={false}
        />
    );
}

merchantOverview.propTypes = {
    list: PropTypes.array
};

export default merchantOverview;
